module.exports = __webpack_public_path__ + "static/img/null.27c2c5ad.png";